import type { SvgComponent } from '@/types/SvgComponent';

export const CaretIcon: SvgComponent = ({ title, ...props }) => {
  return (
    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      {title ? <title>{title}</title> : null}
      <path d="M9.75 4.5L6 8.25L2.25 4.5" stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};
